import isNil from 'lodash/isNil';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { VisuallyHiddenSpan } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

const SecondaryLogo = ({ secondaryLogoData }) => {
  // needed to construct the secondary logo
  const { asset, url, backgroundSize, backgroundPosition } = secondaryLogoData;

  const secondaryLogoUrl = url;
  const hasSecondaryLogo = !isNil(asset);
  const hasSecondaryLogoUrl = !isNil(url) && url !== '';

  const secondaryLogoStyle = hasSecondaryLogo
    ? {
      backgroundSize,
      backgroundPosition,
      backgroundImage: `url(${asset.originalImage})`,
    }
    : {};

  const secondaryLogoClassName = classNames({
    'is-link': hasSecondaryLogoUrl,
  });

  return (
    <a
      target='_blank'
      href={secondaryLogoUrl}
      style={secondaryLogoStyle}
      className={classNames(
        'header-thumbnail',
        'secondary-thumbnail',
        secondaryLogoClassName
      )}
      tabIndex={0}
    >
      <VisuallyHiddenSpan>Visit {secondaryLogoUrl}</VisuallyHiddenSpan>
    </a>
  );
};

SecondaryLogo.propTypes = {
  /**
   * An object containing the necessary data to present the secondary logo is expected
   * Not all fields are used - refer to the destructuring at L11
   */
  secondaryLogoData: PropTypes.shape({
    /**
     * Content ID
     */
    contentUuid: PropTypes.number,
    /**
     * Background size to be applied to image
     */
    backgroundSize: PropTypes.string,
    /**
     * Background position to be applied to image
     */
    backgroundPosition: PropTypes.string,
    /**
     * Object containing additional information about the image
     */
    contentItem: PropTypes.object,
    /**
     * Object containing additional information about the image. In this case
     * we are interested in the originalImage field which has the link to the image
     */
    asset: PropTypes.object,
  }),
};

export default SecondaryLogo;
